module.exports = __webpack_public_path__ + "static/media/detail_0035_f.38301218.jpg";